/* eslint-disable linebreak-style */
import styled from 'styled-components';

const Container = styled.div`
  margin-top: 20px;
`;

export default Container;
